import { render, staticRenderFns } from "./AltinnSendTaxToFakturabankButton.vue?vue&type=template&id=5e7afea4&scoped=true&"
import script from "./AltinnSendTaxToFakturabankButton.vue?vue&type=script&lang=ts&"
export * from "./AltinnSendTaxToFakturabankButton.vue?vue&type=script&lang=ts&"
import style0 from "./AltinnSendTaxToFakturabankButton.vue?vue&type=style&index=0&id=5e7afea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7afea4",
  null
  
)

export default component.exports